import { render, staticRenderFns } from "./riesgosGeneralesShow.vue?vue&type=template&id=7872422e&scoped=true&"
import script from "./riesgosGeneralesShow.vue?vue&type=script&lang=js&"
export * from "./riesgosGeneralesShow.vue?vue&type=script&lang=js&"
import style0 from "./riesgosGeneralesShow.vue?vue&type=style&index=0&id=7872422e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7872422e",
  null
  
)

export default component.exports